export enum OauthResponseTypes {
  code = 'code',
  token = 'token',
}
